export const FLOWS = {
  CHOOSE: 'choose',
  PATIENT: 'patient',
  PRACTICE: 'practice',
}

export const STEPS = {
  CHOOSE_ROLE: 'CHOOSE_ROLE',
  PATIENT_FORM: 'PATIENT_FORM',
  PATIENT_VERIFY: 'PATIENT_VERIFY',
  PRACTICE_FORM: 'PRACTICE_FORM',
  PRACTICE_VERIFY: 'PRACTICE_VERIFY',
  ACCOUNT_MANAGER: 'ACCOUNT_MANAGER',
  APPROVAL_WAIT: 'APPROVAL_WAIT',
}

export const VERIFY_METHOD = {
  SMS: 1,
  EMAIL: 2,
}

export const PRACTICE_STEPS = [
  { id: 1, label: 'Registration', description: 'Practice and account details' },
  { id: 2, label: 'Verification', description: 'Confirm email or phone' },
  { id: 3, label: 'Account manager', description: 'Optional team member' },
  { id: 4, label: 'Application approval', description: 'Review by our team' },
]

export const PATIENT_STEPS = [
  { id: 1, label: 'Registration', description: 'Your account details' },
  { id: 2, label: 'Verification', description: 'Confirm email or phone' },
]
